import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=cb088dc4&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb088dc4')) {
      api.createRecord('cb088dc4', component.options)
    } else {
      api.reload('cb088dc4', component.options)
    }
    module.hot.accept("./NotificationsList.vue?vue&type=template&id=cb088dc4&", function () {
      api.rerender('cb088dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/NotificationsList.vue"
export default component.exports